import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {InvoiceLine} from 'app/blocks/model/invoice-line.model';
import {Run} from 'app/blocks/model/run.model';

export interface IInvoiceRunLine extends IBaseEntity {
    id?: number;
    run: any;
    runId: number;
    rate: number;
    discount: number;
    total: number;
}

export class InvoiceRunLine extends BaseEntity implements IInvoiceRunLine {
    public id?: number;
    public run: any;
    public runId: number;
    public rate: number;
    public discount: number;
    public total: number;

    constructor(invoiceRunLine?: any) {
        super();
        if (invoiceRunLine) {
            this.id = invoiceRunLine.id;
            this.run = invoiceRunLine.run ? invoiceRunLine.run : new Run({id: invoiceRunLine.runId});
            this.runId = invoiceRunLine.run ? invoiceRunLine.run.id : invoiceRunLine.runId;
            this.rate = invoiceRunLine.rate;
            this.discount = invoiceRunLine.discount;
            this.total = invoiceRunLine.total;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): InvoiceRunLine {
        return new InvoiceRunLine(this);
    }
}
